import { useRouteError, isRouteErrorResponse } from 'react-router';

export function ErrorBoundary() {
  const error = useRouteError();
  let message: React.ReactNode;

  if (isRouteErrorResponse(error)) {
    if (error.status === 401) {
      message = 'Sorry, you are not currently logged in.';
    } else if (error.status === 404) {
      message = 'Sorry, we are having a problem retrieving data.';
    } else {
      throw new Error(
        `Unexpected caught response with status: ${error.status}`,
      );
    }
  } else {
    message = (
      <h1>Oops, looks like something is broken. We are working on it!</h1>
    );
  }

  return (
    <div className="w-full h-screen flex flex-row">
      <div className="lg:max-w-screen-lg lg:mx-auto lg:mt-6 lg:mb-6 lg:p-4 w-full">
        {message}
      </div>
    </div>
  );
}
